import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import user from './user';
import table from './table';
import views from './views';
import source from './source';

export default (history) => combineReducers({
  router: connectRouter(history),
  user,
  table,
  views,
  source
});
